<div class="card-group">
  <div *ngFor="let imgUrl of imgUrls; index as i" class="thumbnail-card card">
    <img (click)="onClick(i, imgUrl)" [src]="imgUrl.thumb" class="widget-thumbnail hover-pointer">
  </div>
</div>
